import { render, staticRenderFns } from "./SliderCreate.vue?vue&type=template&id=226d3f9b"
import script from "./SliderCreate.vue?vue&type=script&lang=ts"
export * from "./SliderCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports